'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRoles = setRoles;
var SET_USER_ROLES = exports.SET_USER_ROLES = 'SET_USER_ROLES';

function setRoles(roles) {
  return {
    type: SET_USER_ROLES,
    payload: roles
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/UserContainer/actions.js
 ** module id = 172
 ** module chunks = 0
 **/